<template>
  <div>
    <Header />
    <main class="main">

      <div class="confirm-wrapper">
        <div v-html="content" class="wysiwyg"></div>
      </div>

    </main>
  </div>
</template>

<script>
import Header from '@/components/Header'

export default {
  name: 'page-template',
  props: ['slug'],
  components: {
    Header
  },
  data () {
    return {
      content: '<p></p>'
    }
  },
  watch: {
    '$route.params.slug' (newSlug, oldSlug) {
      this.getDetails(this.slug)
    }
  },
  created () {
    this.getDetails(this.slug)
  },
  mounted () {
    this.$store.state.isLoading = false
  },
  methods: {
    backStep () {
      this.$router.push({ path: '/home' })
    },
    getDetails (slug) {
      console.log('method', this.slug)
      this.$http.pageDetails(this.slug)
        .then((res) => {
          if (res.status !== undefined) {
            // console.log(res.data.content)
            this.content = res.data.content
          } else {
            console.log('inside error', res.response.data.message)
          }
        })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../scss/variables.scss";
  .main {
    position: relative;
    min-height: auto;
    margin: 0;
    text-align: center;
  }

  .confirm-wrapper {
    padding: 80px 6%;
    text-align: left;
    background: #1f1f1f;
  }

</style>
